import {createSelector} from "reselect";
import {
	getIsLoadingAvatars,
	getIsLoadingSettings,
	getUserAchievementsIsLoading,
} from "modules/selectors";

export const getIsLoadingLanding = createSelector(
	getIsLoadingSettings,
	getIsLoadingAvatars,
	getUserAchievementsIsLoading,
	(isLoadingSettings, isLoadingAvatars, userAchievementsIsLoading) =>
		isLoadingSettings || isLoadingAvatars || userAchievementsIsLoading
);
